import https from "./https-common";

const getAllTrustBadge = (shopDomain) => {
  let shop = shopDomain.replace(".myshopify.com", "");
  shop = shop.replace("https://", "");
  return https.get(`/trust-badges?shop=${shop}`);
};

const getTrustBadgeBadgeById = (id) => {
  return https.get(`/trust-badges/${id}`);
};

const TrustBadgeService = {
  getAllTrustBadge,
  getTrustBadgeBadgeById,
};

export default TrustBadgeService;
